<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">

    <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
        <template v-slot:main>
            <head-utils title="Criar Produto"/>
            <breadcrumb
                    :items="[{label: 'Pesquisa de Produtos', path: '/products'}, {label: 'Criar Produto', path: '/products/new'}]"/>

            <form @submit.prevent.stop="submit" novalidate>
                <ibox>
                    <template v-slot:title v-if="!$appUtils.isMobile()">
                        <h5>Dados do Produto</h5>
                    </template>
                    <template v-slot:content>
                        <div class="container-fluid-grid">
                            <div class="form-row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="productEditName" class="required">Nome</label>
                                        <input type="text" id="productEditName" :class="{'is-invalid': errors['name']}" class="form-control form-control-sm" v-model="entity.name"/>
                                        <field-messages :errors="errors.name"/>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="productEditCategory" class="required">Categoria</label>
                                        <select id="productEditCategory" class="form-control form-control-sm" :key="entity.id" v-model="entity.product_category_id">
                                            <option disabled>[SELECIONE]</option>
                                            <option v-for="c in categories"
                                                    :key="c.id"
                                                    :value="c.id"
                                                    :selected="c.id === entity.product_category_id">{{c.name}}</option>
                                        </select>
                                        <field-messages :errors="errors.product_category_id"/>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="productEditPercComm" class="required">Percentual Comissão</label>
                                        <input id="productEditPercComm" type="number" :class="{'is-invalid': errors.percentage_commission}" class="t-r form-control form-control-sm" step="0.1" v-model="entity.percentage_commission"/>
                                        <field-messages :errors="errors.percentage_commission"/>
                                    </div>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>Peso ou Saca?</label>
                                        <div class="checkbox-inline" style="padding: 5px">
                                            <label><input type="checkbox" v-model="isPackage" @change="changePackage" class="checkbox green m"/> <span class="c-theme f-w-300">{{isPackage ? 'SACA' : 'PESO'}}</span></label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="productEditQtdPack" :class="{required: isPackage}">Quantidade Saca</label>
                                        <input id="productEditQtdPack" type="number" :class="{'is-invalid': errors['quantity_package']}" class="t-r form-control form-control-sm" step="1" :disabled="!isPackage" v-model="entity.quantity_package"/>
                                        <field-messages :errors="errors['quantity_package']"/>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>Tributado ou Diferido?</label>
                                        <div class="checkbox-inline" style="padding: 5px">
                                            <label><input type="checkbox" v-model="isTrib" @change="entity.tributacao = isTrib ? 'tributado' : 'diferido'" value="tributado" class="checkbox green m"/> <span class="c-theme f-w-300">{{isTrib ? 'TRIBUTADO' : 'DIFERIDO'}}</span></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <div class="container-fluid-grid">
                            <div class="row">
                                <div class="col t-r">
                                    <div class="btn-group btn-group-sm" role="group" aria-label="Comandos de Pesquisa">
                                        <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon
                                                icon="sync"/> Limpar</button>
                                        <router-link to="/products" class="btn btn-dark btn-sm"><svg-icon icon="search"/> Pesquisar</router-link>
                                        <button type="submit" class="btn btn-theme-1 btn-sm"><svg-icon icon="save"/> Salvar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </ibox>
            </form>
        </template>
    </DefaultTmpl>
</template>

<script>
    import CRUDEdit from '@/mixins/CRUDEdit'
    import {createNamespacedHelpers} from 'vuex'
    import FieldMessage from "../../components/particles/FieldMessage";

    const {mapActions, mapGetters} = createNamespacedHelpers('products');

    export default {
        name: "ProductsEdit",
        components: {FieldMessage},
        mixins: [
            CRUDEdit.mount('products')
        ],
        data() {
            return {
                isPackage: false,
                isTrib: true
            }
        },
        methods: {
            ...mapActions(['loadCategories']),
            createEntity() {
                return {
                    product_category_id: (this.categories && this.categories.length > 0 ? this.categories[0].id : 0)
                    ,package_type: 'weight'
                    ,tributacao: 'tributado'
                }
            },
            onLoadSuccess(entity) {
                this.isPackage = entity.package_type === 'package';
                this.isTrib = entity.tributacao === 'tributado';
                this.entity = {...entity};
            },
            changePackage() {
                this.entity = {...this.entity, package_type: (this.isPackage ? 'package': 'weight'), quantity_package: null};
            }
        },
        computed: {
            ...mapGetters(['categories'])
        },
        beforeMount() {
            this.loadCategories()
                .then(data => {
                    this.entity = {...this.entity, product_category_id: data[0].id};
                });
        }
    }
</script>
